module.exports = __webpack_public_path__ + "7ce8514382f88fbd711c152ada3ef2e9.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/livingrooms_thumb.jpg
// module id = 476
// module chunks = 0